export enum ObsoleteDate {
    ADD_OBSOLETE_DATE_STRAT = "ADD_OBSOLETE_DATE_STRAT",
    ADD_OBSOLETE_DATE_SUCCESS = "ADD_OBSOLETE_DATE_SUCCESS",
    ADD_OBSOLETE_DATE_FAIL = "ADD_OBSOLETE_DATE_FAIL",
}